var quizQuestions = [
    {
        question: "Kuća 60 m² na Sitoniji (Halkidiki)",
        answers: [
            {
                type: "none",
                content: "100 000 €",
                points: 1
            },
            {
                type: "gold",
                content: "180 000 €",
                points: 10
            },
            {
                type: "silver",
                content: "210 000 €",
                points: 5
            },
            {
                type: "bronze",
                content: "250 000 €",
                points: 2
            }
        ],
        price: 180000,
        images: [
            {
                url: 'https://cdn2.mouzenidis.com/userfiles/realtyobjects/pictureshd/25049/557399.jpeg',
                alt: ''
            },
            {
                url: 'https://cdn2.mouzenidis.com/userfiles/realtyobjects/pictureshd/25049/556759.jpeg',
                alt: ''
            }, 
            {
                url: 'https://cdn2.mouzenidis.com/userfiles/realtyobjects/pictureshd/25049/552423.jpeg',
                alt: ''
            },
            {
                url: 'https://cdn2.mouzenidis.com/userfiles/realtyobjects/pictureshd/25049/556759.jpeg',
                alt: ''
            },
            {
                url: 'https://cdn2.mouzenidis.com/userfiles/realtyobjects/pictureshd/25049/552423.jpeg',
                alt: ''
            },

        ]
    },
    {
        question: "Vila 132 m² na Sitoniji (Halkidiki)",
        answers: [
            {
                type: "none",
                content: "300 000 €",
                points: 1
            },
            {
                type: "gold",
                content: "500 000 €",
                points: 10
            },
            {
                type: "silver",
                content: "450 000 €",
                points: 5
            },
            {
                type: "bronze",
                content: "600 000 €",
                points: 2
            }
        ],
        price: 500000,
        images: [
            {
                url: 'https://cdn2.mouzenidis.com/userfiles/realtyobjects/pictureshd/25061/332322.jpeg',
                alt: ''
            },
            {
                url: 'https://cdn2.mouzenidis.com/userfiles/realtyobjects/pictureshd/25061/332321.jpeg',
                alt: ''
            }, 
            {
                url: 'https://cdn2.mouzenidis.com/userfiles/realtyobjects/pictureshd/25061/332323.jpeg',
                alt: ''
            },
            {
                url: 'https://cdn2.mouzenidis.com/userfiles/realtyobjects/pictureshd/25061/332325.jpeg',
                alt: ''
            },
            {
                url: 'https://cdn2.mouzenidis.com/userfiles/realtyobjects/pictureshd/25061/332327.jpeg',
                alt: ''
            },

        ]
    },
    {
        question: "Kuća 95 m² na Tasosu",
        answers: [
            {
                type: "none",
                content: "90 000 €",
                points: 1
            },
            {
                type: "gold",
                content: "125 000 €",
                points: 10
            },
            {
                type: "silver",
                content: "150 000 €",
                points: 5
            },
            {
                type: "bronze",
                content: "200 000 €",
                points: 2
            }
        ],
        price: 125000,
        images: [
            {
                url: 'https://cdn2.mouzenidis.com/userfiles/realtyobjects/pictureshd/31479/479097.jpeg',
                alt: ''
            },
            {
                url: 'https://cdn2.mouzenidis.com/userfiles/realtyobjects/pictureshd/31479/479093.jpeg',
                alt: ''
            }, 
            {
                url: 'https://cdn2.mouzenidis.com/userfiles/realtyobjects/pictureshd/31479/531546.jpeg',
                alt: ''
            },
            {
                url: 'https://cdn2.mouzenidis.com/userfiles/realtyobjects/pictureshd/31479/531547.jpeg',
                alt: ''
            },
            {
                url: 'https://cdn2.mouzenidis.com/userfiles/realtyobjects/pictureshd/31479/479095.jpeg',
                alt: ''
            },

        ]
    },
    {
        question: "Villa 134 m², Pefkohori, Chalkidiki",
        answers: [
            {
                type: "none",
                content: "250 000 €",
                points: 1
            },
            {
                type: "gold",
                content: "450 000 €",
                points: 10
            },
            {
                type: "silver",
                content: "500 000 €",
                points: 5
            },
            {
                type: "bronze",
                content: "300 000 €",
                points: 2
            }
        ],
        price: 45000,
        images: [
            {
                url: 'https://tranio.com/photos/adt/74a03eaa/21884957/1024x576.jpg',
                alt: ''
            },
            {
                url: 'https://tranio.com/photos/adt/e406ed63/21884961/1024x576.jpg',
                alt: ''
            }, 
            {
                url: 'https://tranio.com/photos/adt/cbddd07c/21884959/1024x576.jpg',
                alt: ''
            },
            {
                url: 'https://tranio.com/photos/adt/e48e0407/21884960/1024x459.jpg',
                alt: ''
            },
            {
                url: 'https://tranio.com/photos/adt/9787d53d/21884956/1024x576.jpg',
                alt: ''
            },

        ]
    },
    {
        question: "Vila 1100 m², Aleomandra, Mykonos",
        answers: [
            {
                type: "none",
                content: "16 mil €",
                points: 1
            },
            {
                type: "gold",
                content: "12 mil €",
                points: 10
            },
            {
                type: "silver",
                content: "10 mil €",
                points: 5
            },
            {
                type: "bronze",
                content: "9 mil €",
                points: 2
            }
        ],
        price: 13000000,
        images: [
            {
                url: 'https://img.gtsstatic.net/reno/imagereader.aspx?imageurl=https%3A%2F%2Fsir.azureedge.net%2F1103i215%2Fprtzqns5pvb845ac5288wj6c60i215&option=N&permitphotoenlargement=false&w=1200',
                alt: ''
            },
            {
                url: 'https://img.gtsstatic.net/reno/imagereader.aspx?imageurl=https%3A%2F%2Fsir.azureedge.net%2F1103i215%2Fttqh4fz6dt11m5agp5cephez96i215&option=N&permitphotoenlargement=false&w=1200',
                alt: ''
            }, 
            {
                url: 'https://img.gtsstatic.net/reno/imagereader.aspx?imageurl=https%3A%2F%2Fsir.azureedge.net%2F1103i215%2Fesjt6z6evkfp4vpwpsym9x7x13i215&option=N&permitphotoenlargement=false&w=1200',
                alt: ''
            },
            {
                url: 'https://img.gtsstatic.net/reno/imagereader.aspx?imageurl=https%3A%2F%2Fsir.azureedge.net%2F1103i215%2F7dbjjkbg23kc4ba04tjx5qf0e3i215&option=N&permitphotoenlargement=false&w=1200',
                alt: ''
            },
            {
                url: 'https://img.gtsstatic.net/reno/imagereader.aspx?imageurl=https%3A%2F%2Fsir.azureedge.net%2F1103i215%2Fe0zy622wa2npmfpg121gfw6xv2i215&option=N&permitphotoenlargement=false&w=1200',
                alt: ''
            },

        ]
    },
    {
        question: "Četvorosoban stan 195 m², garaža + parking, Zvezdara, Beograd",
        answers: [
            {
                type: "none",
                content: "300 000 €",
                points: 1
            },
            {
                type: "gold",
                content: "355 000 €",
                points: 10
            },
            {
                type: "silver",
                content: "400 000 €",
                points: 5
            },
            {
                type: "bronze",
                content: "500 000 €",
                points: 2
            }
        ],
        price: 355000,
        images: [
            {
                url: 'https://img.nekretnine.rs/foto/Zml0LWluLzEwNjR4Nzk4L2NlbnRlci9taWRkbGUvZmlsdGVyczpxdWFsaXR5KDgwKQ==/nek/QcAMylVFv_fss?st=fXQewRaZn91BGSh5zmvAx-6vvlLW2Vo1ZCfsmIxqJ4c&ts=1601635245&e=0',
                alt: ''
            },
            {
                url: 'https://img.nekretnine.rs/foto/Zml0LWluLzEwNjR4Nzk4L2NlbnRlci9taWRkbGUvZmlsdGVyczpxdWFsaXR5KDgwKQ==/nek/qvlaGEZwT_fss?st=JOyEemQ5KoVoNmwSPvfLOp5UvLr6ADCIjBcLLy40n_w&ts=1601635355&e=0',
                alt: ''
            }, 
            {
                url: 'https://img.nekretnine.rs/foto/Zml0LWluLzEwNjR4Nzk4L2NlbnRlci9taWRkbGUvZmlsdGVyczpxdWFsaXR5KDgwKQ==/nek/8JisACg9C_fss?st=aD1k8rKiu_Jct3VZCRNhbGl4OYBwfoWQaWm6P6AU7D0&ts=1601635343&e=0',
                alt: ''
            },
            {
                url: 'https://img.nekretnine.rs/foto/Zml0LWluLzEwNjR4Nzk4L2NlbnRlci9taWRkbGUvZmlsdGVyczpxdWFsaXR5KDgwKQ==/nek/llTiaDtOO_fss?st=UDz-gf0X-adjXlYuS_kdSmJ3FreYBPBcKmFcTWEPOcc&ts=1601635253&e=0',
                alt: ''
            },
            {
                url: 'https://img.nekretnine.rs/foto/Zml0LWluLzEwNjR4Nzk4L2NlbnRlci9taWRkbGUvZmlsdGVyczpxdWFsaXR5KDgwKQ==/nek/pWmLN1bfrW_fss?st=HDKDwUj04JomgWVCy2EGHUmMxnHX0InB-uoXr_Ytaiw&ts=1601635363&e=0',
                alt: ''
            },

        ]
    },
    {
        question: "Petosobna kuća 300 m², Klisa, Novi Sad, Srbija",
        answers: [
            {
                type: "none",
                content: "194 000 €",
                points: 1
            },
            {
                type: "gold",
                content: "164 000 €",
                points: 10
            },
            {
                type: "silver",
                content: "154 000 €",
                points: 5
            },
            {
                type: "bronze",
                content: "134 000 €",
                points: 2
            }
        ],
        price: 164000,
        images: [
            {
                url: 'https://img.nekretnine.rs/foto/Zml0LWluLzEwNjR4Nzk4L2NlbnRlci9taWRkbGUvZmlsdGVyczpxdWFsaXR5KDgwKQ==/nek/tEw9Y8KP9_fss?st=LqrJPYBEkpTl2vztD_ID1LewLrFdhRFeRZo0XmFYkEY&ts=1601768205&e=0',
                alt: ''
            },
            {
                url: 'https://img.nekretnine.rs/foto/Zml0LWluLzEwNjR4Nzk4L2NlbnRlci9taWRkbGUvZmlsdGVyczpxdWFsaXR5KDgwKQ==/nek/Y_JwjRHFj_fss?st=aQqy1e60_Y4B0qv_xyN5vLBr-kqsi8byx4od-BO1qlI&ts=1601768182&e=0',
                alt: ''
            }, 
            {
                url: 'https://img.nekretnine.rs/foto/Zml0LWluLzEwNjR4Nzk4L2NlbnRlci9taWRkbGUvZmlsdGVyczpxdWFsaXR5KDgwKQ==/nek/bbUG0jw9f_fss?st=bs5NFjoDdo484B7_5CfWQMS_EbQBWg5F5_4sQ3KW45Q&ts=1601768184&e=0',
                alt: ''
            },
            {
                url: 'https://img.nekretnine.rs/foto/Zml0LWluLzEwNjR4Nzk4L2NlbnRlci9taWRkbGUvZmlsdGVyczpxdWFsaXR5KDgwKQ==/nek/gG5f07E4S_fss?st=GSMR2aoE4lNb03iqSVbc9xqFFwhgO5rCjIThr1K_nzM&ts=1601768185&e=0',
                alt: ''
            },
            {
                url: 'https://img.nekretnine.rs/foto/Zml0LWluLzEwNjR4Nzk4L2NlbnRlci9taWRkbGUvZmlsdGVyczpxdWFsaXR5KDgwKQ==/nek/5_cMugNEe_fss?st=VlKYbBhdRHJAf0tRCU0gzuVsN2lHhNYaJ9h9m5DE-74&ts=1601768187&e=0',
                alt: ''
            },

        ]
    },
    {
        question: "Apartman 56 m², Čolovića brdo, Zlatibor",
        answers: [
            {
                type: "none",
                content: "90 000 €",
                points: 1
            },
            {
                type: "gold",
                content: "64 000 €",
                points: 10
            },
            {
                type: "silver",
                content: "50 000 €",
                points: 5
            },
            {
                type: "bronze",
                content: "80 000 €",
                points: 2
            }
        ],
        price: 64000,
        images: [
            {
                url: 'https://img.halooglasi.com/slike/oglasi/Thumbs/200814/l/apartman-56-kvm-colovica-brdo-zlatibor-5425635828239-71792378712.jpg',
                alt: ''
            },
            {
                url: 'https://img.halooglasi.com/slike/oglasi/Thumbs/200814/l/apartman-56-kvm-colovica-brdo-zlatibor-5425635828239-71792378704.jpg',
                alt: ''
            }, 
            {
                url: 'https://img.halooglasi.com/slike/oglasi/Thumbs/200814/l/apartman-56-kvm-colovica-brdo-zlatibor-5425635828239-71792378706.jpg',
                alt: ''
            },
            {
                url: 'https://img.halooglasi.com/slike/oglasi/Thumbs/200814/l/apartman-56-kvm-colovica-brdo-zlatibor-5425635828239-71792378707.jpg',
                alt: ''
            },
            {
                url: 'https://img.halooglasi.com/slike/oglasi/Thumbs/200814/l/apartman-56-kvm-colovica-brdo-zlatibor-5425635828239-71792378709.jpg',
                alt: ''
            },

        ]
    },
    {
        question: "Kuća 250 m², Sutomore, Bar, Crna Gora",
        answers: [
            {
                type: "none",
                content: "150 000 €",
                points: 1
            },
            {
                type: "gold",
                content: "200 000 €",
                points: 10
            },
            {
                type: "silver",
                content: "225 000 €",
                points: 5
            },
            {
                type: "bronze",
                content: "170 000 €",
                points: 2
            }
        ],
        price: 200000,
        images: [
            {
                url: 'https://www.realitica.com/images/listing_photos/2269919_img-eb4e0e0b1fdf0642983bafce9c3253c3-v.jpg',
                alt: ''
            },
            {
                url: 'https://www.realitica.com/images/listing_photos/2269919_img-91b4965273f99d74c93d7f77b698b357-v.jpg',
                alt: ''
            }, 
            {
                url: 'http://www.remontenegro.me/wp-content/uploads/2020/03/IMG-c0cccbc83d7fe6e8312745367b101f39-V.jpg',
                alt: ''
            },
            {
                url: 'https://dcjau2yrh9nxo.cloudfront.net/images/nekretnine/sutomore-4.jpg',
                alt: ''
            },
            {
                url: 'http://www.remontenegro.me/wp-content/uploads/2020/03/IMG-51ccacbed2c51a1a99c057a0e5783716-V.jpg',
                alt: ''
            },

        ]
    },
    {
        question: "1.6 Acre Island (all inclusive 😄), Cat Caye Range, Belize",
        answers: [
            {
                type: "none",
                content: "550 000 €",
                points: 1
            },
            {
                type: "gold",
                content: "665 000 €",
                points: 10
            },
            {
                type: "silver",
                content: "615 000 €",
                points: 5
            },
            {
                type: "bronze",
                content: "750 000 €",
                points: 2
            }
        ],
        price: 665000,
        images: [
            {
                url: 'https://www.7thheavenproperties.com/wp-content/uploads/2020/09/island-for-sale-belize-1-1152x600.jpg',
                alt: ''
            },
            {
                url: 'https://www.7thheavenproperties.com/wp-content/uploads/2020/09/island-for-sale-belize-2-1152x600.jpg',
                alt: ''
            }, 
            {
                url: 'https://www.7thheavenproperties.com/wp-content/uploads/2020/09/island-for-sale-belize-4-1152x600.jpg',
                alt: ''
            },
            {
                url: 'https://www.7thheavenproperties.com/wp-content/uploads/2020/09/island-for-sale-belize-5-1152x600.jpg',
                alt: ''
            },
            {
                url: 'https://www.7thheavenproperties.com/wp-content/uploads/2020/09/island-for-sale-belize-7-1152x600.jpg',
                alt: ''
            },

        ]
    }
]

export default quizQuestions;
